import React, { FC } from 'react'
import { Button, Heading, Modal, Text } from '@afterpaytouch/core'
import { useDisputeTranslation } from '../../../hooks'
import { useConsumerSizes } from '../../../../../utils/responsive'
import { useSection75DisputeModalContext } from '../../Section75DisputeModalContext'
import { TrackOnMount } from '../../../../../integrations/amplitude'
import { TrackingEvent } from '../../../../../model/amplitude'

export const CreateFailure: FC = () => {
  const t = useDisputeTranslation()
  const { textSize } = useConsumerSizes()
  const { closeModal, result } = useSection75DisputeModalContext()

  const heading = result.title ?? t('result:failure:head')
  const subtitle = result.message ?? t('result:failure:unspecific')
  const cta = t('result:failure:closeCTA')
  console.log('Rendering Consumer Protection CreateFailure')

  return (
    <>
      <TrackOnMount eventName={TrackingEvent.VIEWED_CREATE_DISPUTE_FAILURE} />
      <Modal.Header divider={true}>
        <div className='text-center'>
          <Heading size='L'>{heading}</Heading>
        </div>
      </Modal.Header>
      <Modal.Content>
        <Text size={textSize}>{subtitle}</Text>
        <div className='mt-9'>
          <Button padding='Fluid' onClick={closeModal}>
            {cta}
          </Button>
        </div>
      </Modal.Content>
    </>
  )
}
